const SERVICE_TYPES = {
  HTTPS: 'https',
  HTTP2: 'http2',
  TCP: 'tcp',
  UDP: 'udp',
};
export default SERVICE_TYPES;
